import type {HTMLAttributes} from "react";

export type DsSkeletonVariant = "text" | "title" | "block";

export type DsSkeletonProps = HTMLAttributes<HTMLDivElement> & {
  variant?: DsSkeletonVariant;
  width?: string | number;
  height?: string | number;
};

export function DsSkeleton({variant = "text", width, height, className, style, ...props}: DsSkeletonProps) {
  const cls = ["cc-ds-skeleton", `cc-ds-skeleton--${variant}`, className || ""].filter(Boolean).join(" ");
  const mergedStyle = {
    ...style,
    ...(width != null ? {width: typeof width === "number" ? `${width}px` : width} : {}),
    ...(height != null ? {height: typeof height === "number" ? `${height}px` : height} : {})
  };
  return <div className={cls} style={mergedStyle} aria-hidden="true" {...props} />;
}
